import AuthContext from "context/AuthContext";
import ProfileContext from "context/ProfileContext";
import React, { useContext, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AgreementTC from "../AgreementTC";
import ProfileInfo from "../ProfileCompletion/ProfileInfo";
import AdminInfo from "./AdminInfo";

const AdminProfileController = () => {
  let { user } = useContext(AuthContext);
  let { uploader } = useContext(ProfileContext);
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState({
    phone_number: "",
    about_me: "",
    instagram_handle: "",
    twitter_handle: "",
    tiktok_handle: "",
    facebook_handle: "",
    latitude: "",
    longitude: "",
    address: "",
    street_number: "",
    city: "",
    state: "",
    zip_code: "",
    profile_picture_id: "",
    imageFile: "",
    tag: "profile_picture",
    type: "image",
    extension: "jpg",
    store_email: user.email,
    id: user.uid,
    accounts: [
      {
        store_email: user.email,
      },
    ],
  });

  const [currentStep, setCurrentStep] = useState(0);

  const makeRequest = (formData) => {
    const response = uploader(formData);
    response
      .then(function (response) {
        if (response.status === 200) {
          navigate("/user/welcome");
        }
      })
      .catch(function (err) {
        console.error("Error Occured");
      });
  };

  const handleNextStep = (newData, final = false) => {
    setProfileData((prev) => ({ ...prev, ...newData }));

    if (final) {
      makeRequest(newData);
      return;
    }
    setCurrentStep((prev) => prev + 1);
  };

  const steps = [
    <AdminInfo next={handleNextStep} data={profileData} />,
    <ProfileInfo next={handleNextStep} data={profileData} />,
    <AgreementTC next={handleNextStep} data={profileData} />,
  ];

  return (
    <div>
      <ProgressBar
        className="step-progress-bar"
        variant="info"
        now={currentStep + 1}
        min={0}
        max={3}
        label={`${currentStep + 1}/3`}
      />
      {steps[currentStep]}
    </div>
  );
};

export default AdminProfileController;
